import { User, UserLeaveRule } from '@/types/user';

export default {
  namespaced: true,
  state: {
    showModal: false,
    form: {
      id: null,
      roles: [
        { id: 0 },
      ],
      name: '',
      password: '',
      email: '',
    } as User,
    rules: [
      {
        id: 1,
        leaveTypeId: 2,
        period: 'yearly',
        value: 666,
      },
      {
        id: 1,
        leaveTypeId: 2,
        period: 'monthly',
        value: 42,
      },
      {
        id: 1,
        leaveTypeId: 2,
        period: 'daily',
        value: 312,
      },
    ] as UserLeaveRule[],
    showRulesModal: false,
  },
  mutations: {
    updateField(state: any, payload: object) {
      state.form = {
        ...state.form,
        ...payload,
      };
    },
    set(state: any, payload: User) {
      state.form = payload;
    },
    setRules(state: any, payload: UserLeaveRule[]) {
      state.rules = payload;
    },
    show(state: any, payload: boolean) {
      state.showModal = payload;
    },
    showRulesModal(state: any, payload: boolean) {
      state.showRulesModal = payload;
    },
  },
  actions: {
    resetBuilder({ commit }: {commit: any}): void {
      commit('set', {
        id: null,
        roles: [
          { id: 0 },
        ],
        name: '',
        password: '',
        email: '',
      } as User);
      commit('show', false);
    },
    showModal({ commit }: {commit: any}, payload?: User) {
      if (payload) {
        commit('set', payload);
      }
      commit('show', true);
    },
    showRulesModal({ commit }: {commit: any}, payload?: UserLeaveRule[]) {
      if (payload) {
        commit('setRules', payload);
      }
      commit('showRulesModal', true);
    },
    resetRulesModal({ commit }: {commit: any}): void {
      commit('setRules', []);
      commit('showRulesModal', false);
    },
  },
  getters: {
    form: (state: any): User => state.form,
    rules: (state: any): User => state.rules,
    showModal: (state: any): boolean => state.showModal,
    showRulesModal: (state: any): boolean => state.showRulesModal,
  },
};

